import { useInView } from 'react-intersection-observer';
import schoolLogoLong from '../images/laschool-logo-long.svg';
import heroImagesm from '../images/hero-image-sm.jpg';
import heroImagemd from '../images/hero-image-md.jpg';
import heroImage from '../images/hero-image-elise.jpg';
import herobg from '../images/hero-bg.jpg';
import article1 from '../images/article-1.jpg';
import deco5sm from '../images/deco-5sm.svg';
import deco6sm from '../images/deco-6sm.svg';
import deco7sm from '../images/deco-7sm.svg';
import deco8sm from '../images/deco-8sm.svg';
import badgeowned from '../images/badge-owned.png';
import chat from '../images/chat.svg';
import FormationColumns from './FormationColumns';
import SVG from 'react-inlinesvg';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

function Home({ isModalOpen, setIsModalOpen }: { isModalOpen: boolean; setIsModalOpen: (value: boolean) => void }) {
    const { t } = useTranslation();

    const currentYear = dayjs().year();

    const [refDeco56, inViewDeco56] = useInView({
        triggerOnce: true,
        threshold: 0.3,
    });

    const [refDeco7, inViewDeco7] = useInView({
        triggerOnce: true,
        threshold: 0.4,
    });

    const [refArticleCertif, inViewCertif] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });

    return (
        <div className="mx-auto max-w-screen-3xl overflow-hidden font-sans">
            {/* <GettingStartedModal isOpen={isGettingStartedOpen} setIsOpen={setIsGettingStartedOpen} /> */}

            <img
                className="absolute left-0 h-full w-full opacity-10 blur-3xl"
                src={herobg}
                alt="hero background blur"
            />
            <nav className="invisible fixed left-0 top-0"></nav>
            <header className="relative flex w-full flex-col items-center py-20">
                <SVG
                    className="pointer-events-none absolute -right-[675px] top-0 min-w-[1000px] md:-right-96 md:-top-20 lg:-right-96 lg:-top-10 xl:-right-72 2xl:-right-48 3xl:-right-0"
                    src={`/images/deco/deco-1-2.svg`}
                    cacheRequests={false}
                />
                <div className="relative flex max-w-[90%] flex-col gap-4 lg:w-[875px] xl:w-[1000px] xl:flex-col xl:gap-10">
                    <img className="absolute top-12 h-[44px]" src={schoolLogoLong} alt="Course line" />
                    <div className="absolute z-5 top-[127px] -left-7 w-[320px] h-[90px] bg-gradient-to-r from-[#D0F2F5] to-[#D0F2F500] to-90% rounded-full"></div>
                    <h1 className="relative z-10 text-7xl mt-32 leading-[5.7rem] font-semibold text-[#262628]">
                        {t('school_everything_fine')}, <br></br> {t('school_follow_the_path')} !
                    </h1>
                    <div className="absolute z-5 top-[222px] left-[290px] w-[320px] h-[90px] bg-gradient-to-l from-[#BCCBFF] to-[#BCCBFF00] to-80% rounded-full"></div>
                    <h2 className="relative w-3/4 text-lg font-medium text-grey sm:w-[550px] sm:text-xl">
                        {t('school_onboarding')}
                    </h2>
                </div>

                {/* <button
                    className="active: shadow-blue hover:shadow-blueactive relative mt-9 cursor-pointer rounded-full bg-gradient-to-b from-[#6F7DFF] to-[#5D6DFA] px-12 py-3 text-center text-lg font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none"
                    onClick={openGettingStartedModal}
                >
                    {t('school_begin')}
                </button> */}
                <div className="relative w-full">
                    <SVG
                        className="pointer-events-none absolute -right-[200px] -top-32 hidden min-w-[820px] md:-right-[270px] md:top-0 md:block lg:-right-[250px] lg:-top-28 xl:-right-56 xl:-top-10 2xl:-right-40 3xl:-right-0"
                        src={`/images/deco/deco-3.svg`}
                        cacheRequests={false}
                    />

                    <SVG
                        className="pointer-events-none absolute -left-[450px] top-64 z-0 hidden min-w-[1037px] md:-left-[360px] md:top-96 md:block lg:-left-[360px] lg:top-44 xl:-left-80 xl:top-48 2xl:-left-64 2xl:top-48 3xl:-left-20"
                        src={`/images/deco/deco-4.svg`}
                        cacheRequests={false}
                    />

                    <div className="relative mx-auto mt-20 w-[80%] rounded-2xl border border-gray-200 bg-gray-100/50 p-4 backdrop-blur-sm md:w-[80%] lg:w-[875px] xl:w-[1000px]">
                        <img
                            className="rounded-xl border border-gray-200 shadow-xl sm:hidden"
                            src={heroImagesm}
                            alt="Course preview"
                        />
                        <img
                            className="hidden rounded-xl border border-gray-200 shadow-xl sm:block lg:hidden"
                            src={heroImagemd}
                            alt="Course preview"
                        />
                        <img
                            className="hidden rounded-xl border border-gray-200 shadow-xl lg:block"
                            src={heroImage}
                            alt="Course preview"
                        />
                    </div>
                </div>
            </header>
            <section
                className={`relative mt-0 sm:mt-24 flex w-full flex-col items-center gap-24 xl:mt-28 xl:gap-52`}
                ref={refDeco56}
            >
                <img
                    className="pointer-events-none absolute -top-5 z-0 m-auto hidden min-w-[1280px] shrink-0 md:block xl:invisible"
                    src={deco5sm}
                    alt="Course line"
                />
                {inViewDeco56 ? (
                    <SVG
                        className={`pointer-events-none absolute hidden invisible md:block -top-0 z-0 xl:-left-72 xl:-top-20 2xl:-left-32 2xl:-top-20 3xl:-left-0 xl:visible`}
                        src={`/images/deco/deco-5-6.svg`}
                        cacheRequests={false}
                    />
                ) : null}
                {/* 1 CLAIR ET CONCIS */}
                <article
                    className={`flex max-w-[90%] flex-col items-center gap-9 lg:w-[875px] xl:w-[1000px] xl:flex-row xl:items-center xl:gap-20`}
                >
                    <div className="relative w-fit h-fit shrink-0 overflow-hidden rounded-2xl bg-[url('images/purple-blur.jpg')] bg-cover bg-center bg-no-repeat p-[13px] sm:p-[26px] sm:h-[315px] sm:w-[520px]">
                        <img className="z-2 relative rounded-xl shadow-lg" src={article1} alt="article 1 content" />
                    </div>
                    <div className="flex shrink flex-col items-center xl:items-start xl:pt-6">
                        <h2 className="text-2xl sm:text-3xl font-semibold text-text-dark">
                            {t('school_clear_and_concise')}
                        </h2>
                        <p className="mt-4 max-w-lg text-center text-lg sm:text-xl font-medium text-text-grey xl:text-left">
                            {t('school_no_time_to_lose')}
                        </p>
                    </div>
                </article>
                <img
                    className="pointer-events-none absolute top-[560px] z-0 m-auto hidden min-w-[1280px] shrink-0 md:block xl:invisible"
                    src={deco6sm}
                    alt="Course line"
                />
                {/* 2 VERIFICATION AUTOMATIQUE */}
                <article
                    className={`relative z-10 flex max-w-[90%] flex-col items-center gap-9 lg:w-[875px] xl:w-[1000px] xl:flex-row-reverse xl:items-center xl:gap-20 transition-all duration-1000`}
                >
                    <div className="relative w-fit h-fit shrink-0 overflow-hidden rounded-2xl bg-[url('images/green-blur.jpg')] bg-cover bg-center bg-no-repeat p-[26px] sm:h-[315px] sm:w-[520px]">
                        {inViewDeco56 ? (
                            <SVG
                                className="z-2 relative rounded-xl shadow-lg"
                                src={`/images/article2.svg`}
                                cacheRequests={false}
                            />
                        ) : null}
                        <div className="absolute py-[56px] px-[50px] top-0 left-0 w-[520px] h-[315px] flex flex-col justify-between">
                            <p className="text-xl font-semibold text-text-dark">{t('school_home_add_project_cover')}</p>
                            <p className="text-xl font-semibold text-text-dark">{t('school_home_project_name')}</p>
                            <p className="text-xl font-semibold text-text-dark">{t('school_home_project_address')}</p>
                        </div>
                    </div>
                    <div className="flex shrink flex-col items-center xl:items-start xl:pt-6">
                        <h2 className="text-2xl sm:text-3xl font-semibold text-text-dark">
                            {t('school_auto_validation')}
                        </h2>
                        <p className="mt-4 max-w-lg text-center text-lg sm:text-xl font-medium text-text-grey xl:text-left">
                            {t('school_when_you_finish_a_lesson')}
                        </p>
                    </div>
                </article>
                <img
                    className="pointer-events-none absolute bottom-[400px] z-0 m-auto hidden min-w-[1280px] shrink-0 md:block xl:invisible"
                    src={deco7sm}
                    alt="Course line"
                />
                {inViewDeco7 ? (
                    <SVG
                        className="pointer-events-none invisible absolute -top-0 z-0 m-auto hidden w-auto md:block xl:visible xl:top-[770px] 2xl:left-[420px]"
                        src={`/images/deco/deco-7.svg`}
                        cacheRequests={false}
                    />
                ) : null}
                {/* 3 FORMATION EN EQUIPE */}
                <article
                    className="relative z-30 flex max-w-[90%] flex-col items-center gap-9 lg:w-[875px] xl:w-[1000px] xl:flex-row xl:items-center xl:gap-20"
                    ref={refDeco7}
                >
                    <div className="relative w-fit h-fit shrink-0 overflow-hidden rounded-2xl bg-[url('images/red-blur.jpg')] bg-cover bg-center bg-no-repeat p-[26px] sm:h-[315px] sm:w-[520px]">
                        {inViewDeco7 ? (
                            <SVG
                                className="z-2 relative rounded-xl shadow-lg"
                                src={`/images/article3.svg`}
                                cacheRequests={false}
                            />
                        ) : null}
                    </div>
                    <div className="flex shrink flex-col items-center xl:items-start xl:pt-6">
                        <h2 className="text-2xl sm:text-3xl font-semibold text-text-dark">
                            {t('school_team_formation')}
                        </h2>
                        <p className="mt-4 max-w-lg text-center text-lg sm:text-xl font-medium text-text-grey xl:text-left">
                            {t('school_follow_progress_of_your_colleagues')}
                        </p>
                    </div>
                </article>
                {/* CERTIFICATION */}
                <article
                    className={`relative z-20 mt-20 flex w-[90%] flex-col items-center rounded-2xl bg-white p-14 shadow-xl md:w-[700px] lg:w-[760px] xl:items-center transition-all duration-1000 ${
                        inViewCertif ? '-mt-44 opacity-100 scale-100' : 'scale-90 opacity-0'
                    }`}
                    ref={refArticleCertif}
                >
                    <img
                        className="pointer-events-none absolute z-10 hidden min-w-[775px] shrink-0 md:-right-[420px] md:bottom-[200px] md:block lg:-right-[395px] lg:bottom-[200px] xl:invisible"
                        src={deco8sm}
                        alt="Course line"
                    />
                    {inViewCertif ? (
                        <SVG
                            className="pointer-events-none invisible absolute z-10 hidden w-auto md:block xl:visible xl:bottom-[260px] xl:right-[355px]"
                            src={`/images/deco/deco-8.svg`}
                            cacheRequests={false}
                        />
                    ) : null}
                    <img
                        className="relative z-20 -mt-[85px] h-20 w-20"
                        src={badgeowned}
                        alt="Archireport course completed icon"
                    />
                    <div className="z-1 absolute top-0 h-[20px] w-full rounded-t-2xl bg-[url('images/line-blur.jpg')] bg-cover bg-center bg-no-repeat"></div>
                    <div className="mt-8 flex shrink flex-col items-center text-center">
                        <h2 className="text-3xl font-semibold text-text-dark">{t('school_get_your_certificate')}</h2>
                        <p className="mt-4 text-xl font-medium text-text-grey">
                            {t('school_once_the_formation_is_complete_badge')}
                        </p>
                        <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row">
                            <img
                                className="pointer-events-none w-[190px] select-none"
                                src="/images/badge-certified.png"
                                alt="Archireport certified badge"
                            />
                            <img
                                className="pointer-events-none w-[190px] select-none"
                                src="/images/badge-expert.png"
                                alt="Archireport expert badge"
                            />
                        </div>
                    </div>
                </article>
                <div className="absolute bottom-40 z-10 h-[1px] w-full bg-gradient-to-r from-gray-200/0 via-gray-200 to-gray-200/0"></div>
                <div className="absolute bottom-40 left-0 right-0 z-0 m-auto h-[400px] overflow-hidden">
                    <div className="m-auto h-full w-3/4 bg-[url('images/multicolor-blur.jpg')] bg-cover bg-top bg-no-repeat blur-[50px]"></div>
                </div>
            </section>
            <section className="relative mt-36 flex w-full flex-col items-center">
                <div className="flex flex-col lg:w-[875px] xl:w-[1150px] 2xl:w-[1300px]">
                    <h2 className="text-3xl font-semibold text-text-dark">{t('school_general_formations')}</h2>
                    <FormationColumns isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                </div>
            </section>
            <footer className="relative mt-72 flex w-full flex-col items-center pb-16">
                <div className="relative z-20 flex flex-col items-center">
                    <div className="shadow-blue -mt-24 flex w-[90%] flex-col items-center rounded-3xl bg-ar-indigo px-6 py-10 md:w-[800px] md:flex-row md:px-14 lg:w-[900px] xl:w-[1000px]">
                        <div className="flex flex-col items-center text-center md:items-start md:text-left">
                            <h3 className="text-2xl font-semibold text-white">{t('school_questions')}</h3>
                            <p className="mt-4 w-5/6 text-xl font-medium text-white md:w-4/5">
                                {t('school_icon_chat')}
                            </p>
                        </div>
                        <img className="pointer-events-none mt-8 select-none " src={chat} alt="Open chat" />
                    </div>
                    <p className="text-md mt-12 text-center max-w-[80%] font-semibold text-[#91949F]">
                        © Copyright {currentYear} {t('school_la_school_rights_reserved')}.
                    </p>
                    <a
                        href="https://www.archireport.com"
                        target="_blank"
                        rel="noreferrer"
                        className="mt-2 font-semibold text-center text-ar-indigo"
                    >
                        www.archireport.com
                    </a>
                </div>
                <div className="absolute top-0 z-10 h-[1px] w-full bg-gradient-to-r from-gray-300/0 via-gray-300 to-gray-300/0"></div>
                <div className="absolute left-0 right-0 top-0 z-0 m-auto h-[400px] overflow-hidden opacity-40">
                    <div className="m-auto h-full w-3/4 rotate-180 bg-[url('images/multicolor-blur.jpg')] bg-cover bg-top bg-no-repeat blur-[50px] hue-rotate-60"></div>
                </div>
            </footer>
        </div>
    );
}

export default Home;
